import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
   userPasswordResetRequestFeatureKey,
   UserPasswordResetRequestState,
} from './user-password-reset-request.reducer';

export const userPasswordResetRequestFeature = createFeatureSelector<UserPasswordResetRequestState>(
   userPasswordResetRequestFeatureKey
);
export const getUserPasswordResetRequestCallState = createSelector(userPasswordResetRequestFeature, (state) => {
   return state.callState;
});
